import React from 'react'
import { useTranslation } from 'react-i18next'
import { Route, Outlet } from 'react-router-dom'

import { gql, useQuery } from '@apollo/client'
import RouteGuard from 'components/AuthenticatedLayout/RouteGuard/RouteGuard'
import EmptyScreen from 'packages/ui/EmptyScreen'
import { useSites, useHasSitesOnProduction } from 'store'

import Dashboard from './Dashboard/Dashboard'
import SIPs from './SIPs'
import CDRs from './CDRs'

const OPERATION_COUNT_HOTSPOTS = gql`
  query CountHotspots($siteSfId: ID!) {
    count: countHotspots(site_sf_id: $siteSfId)
  }
`

const SiteGuard = () => {
  const [{selected}] = useSites()
  const { t } = useTranslation()
  const { loading, data } = useQuery(OPERATION_COUNT_HOTSPOTS, {
    variables: {
      siteSfId: selected[0].sf_id
    }
  })

  if (loading) {
    return (
      <EmptyScreen icon={'phone-volume'}>
        {t('ui_elements.loading')}
      </EmptyScreen>
    )
  } else if (data.count !== 1) {
    return (
      <EmptyScreen icon={'phone-volume'}>
        {t('ui_elements.alert_multihotspots')}
      </EmptyScreen>
    )
  }

  return <Outlet />
}

const Layout = () => {
  const {t} = useTranslation()
  const [{selected}] = useSites()
  const hasSitesOnProduction = useHasSitesOnProduction()

  return (
    <RouteGuard requiredRoles={['supervision']}>
      {
        selected.length !== 1 || !hasSitesOnProduction
          ? (
            <EmptyScreen icon={'phone-volume'}>
              {hasSitesOnProduction ? t('voip.not_site_selected') : t('ui_elements.service_soon')}
            </EmptyScreen>
          )
          : <SiteGuard />
      }
    </RouteGuard>
  )
}

export const VoipRoutes = ({ path = '/voip' }) => [
  <Route path={path} key="voip" element={<Layout />}>
    <Route path={''} element={<Dashboard />} />
    <Route path={'dashboard'} element={<Dashboard />} />
    <Route path={'sips'} element={<SIPs />} />
    <Route path={'cdrs'} element={<CDRs />} />
  </Route>
]

export default VoipRoutes